export default __webpack_public_path__ + "static/media/enmascarar-detail.fb2d0033.png";